export const styles = {
  icon: 'w-full h-full text-red-medium teair:text-white teair:fill-air-deepBlue',
};
